
import { articleCreationService } from "./articleCreationService";
import { articleUpdateService } from "./articleUpdateService";
import { articleMediaService } from "./articleMediaService";
import { articleQueryService } from "./articleQueryService";
import { articleVersionService } from "./articleVersionService";
import { articleTagService } from "./articleTagService";
import { articleBlockService } from "./articleBlockService";
import { bookmarkService } from "./bookmarkService";
import { extractPlainTextFromBlocks, transformArticleForClient } from "./utils";

export type { ArticleData } from './types';

// Export a unified API for article-related operations
export const articleService = {
  // Storage initialization
  initializeStorageBuckets: articleCreationService.initializeStorageBuckets,
  
  // Creation and update operations
  createArticle: articleCreationService.createArticle,
  updateArticle: articleUpdateService.updateArticle,
  publishArticle: articleUpdateService.publishArticle,
  
  // Media operations
  processArticleMedia: articleMediaService.processArticleMedia,
  
  // Query operations
  getArticleById: articleQueryService.getArticleById,
  getArticlesByAuthor: articleQueryService.getArticlesByAuthor,
  getArticlesByTag: articleQueryService.getArticlesByTag,
  extractPlainTextFromBlocks,
  transformArticleForClient,
  
  // Tag operations
  updateArticleTags: articleTagService.updateArticleTags,
  
  // Version operations
  getArticleVersions: articleVersionService.getArticleVersions,
  revertToVersion: articleVersionService.revertToVersion,
  
  // Block operations
  getBlocksByArticleId: articleBlockService.getBlocksByArticleId,
  createBlock: articleBlockService.createBlock,
  updateBlock: articleBlockService.updateBlock,
  deleteBlock: articleBlockService.deleteBlock,
  reorderBlocks: articleBlockService.reorderBlocks,
  convertBlocksToEditorJS: articleBlockService.convertBlocksToEditorJS,
  convertEditorJSToBlocks: articleBlockService.convertEditorJSToBlocks,
  
  // Bookmark operations
  saveArticle: bookmarkService.saveArticle,
  unsaveArticle: bookmarkService.unsaveArticle,
  isArticleBookmarked: bookmarkService.isArticleBookmarked,
  getUserBookmarks: bookmarkService.getUserBookmarks
};
